import { Pipe, PipeTransform } from '@angular/core';

import { ProperCaseOptionsModel } from './typings/proper-case.options';

@Pipe({
  name: 'properCase'
})
export class ProperCasePipe implements PipeTransform {
  private _defaultOptions : ProperCaseOptionsModel = {
    sentence: false
  };

  transform( value : string, options : ProperCaseOptionsModel = this._defaultOptions ) : string {
    if ( !value ) {
      return value;
    }

    // Sentence mode must not lowercase the rest: acronyms and proper nouns keep their casing.
    if ( options.sentence ) {
      return `${ value.charAt(0).toUpperCase() }${ value.slice(1) }`;
    }

    return value
      .replace(/_/g, ' ') // Replace underscores with spaces
      .toLowerCase()
      .replace(/^(.)|\s(.)/g, (letter) => letter.toUpperCase());
  }
}
